// extracted by mini-css-extract-plugin
export default {"formContent":"BasicInputs_formContent__zPsCH","inputsContaier":"BasicInputs_inputsContaier__D8cQu","customInput":"BasicInputs_customInput__4tRLT"};